import { useEffect } from "react";

import createEventDispatcher from "./createEventDispatcher";
import createEventResponder from "./createEventResponder";

/**
 * @callback GenEventHandler
 * @param {Function} event
 * @param {Array} dependencies
 * @returns void
 */

/**
 * @param {String} eventName - The name for the CustomEvent
 * @param {Array} signatureParams - Keys that will be used to compare the event details in the responder to determine if the CustomEvent should be responded to
 * @param {GenEventHandler|React.useEffect} eventHandler
 *
 * @returns {{responder: GenEventResponder, dispatcher: GenEventDispatcher}}
 */
export default function generateEventPair({
  eventName = "",
  signatureParams = [],
  eventHandler = useEffect
}) {
  return {
    dispatcher: createEventDispatcher({ eventName }),
    responder: createEventResponder({
      eventHandler,
      eventName,
      signatureParams
    })
  };
}
